/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>分时统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
              v-model="selectTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectListTime"
            >
            </el-date-picker>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" :data="orderList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="80" label="时段 / 时">
      </el-table-column>
      <el-table-column  prop="orderCount" label="订单量"  show-overflow-tooltip align="center">
      </el-table-column>
      <el-table-column  prop="salePrice" label="营业额"  show-overflow-tooltip align="center">
      </el-table-column>
      <el-table-column  prop="profit" label="利润"  show-overflow-tooltip align="center">
        <template slot-scope="scope">
          <span>{{scope.row.profit.toFixed(2)}}</span>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="订单量">
              <el-input size="small" v-model="editForm.orderNum" auto-complete="off" placeholder="订单号" disabled></el-input>
            </el-form-item>
            <el-form-item label="营业额">
              <el-input size="small" v-model="editForm.createTime" auto-complete="off" placeholder="订单号" disabled></el-input>
            </el-form-item>
            <el-form-item label="利润">
              <el-input size="small" v-model="editForm.payMethod" auto-complete="off" placeholder="请输入商户号" disabled></el-input>
            </el-form-item>
            <el-form-item label="利润">
              <el-input size="small" v-model="editForm.subtract" auto-complete="off" placeholder="请输入微信子商户" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付金额">
              <el-input size="small" v-model="editForm.price" auto-complete="off" placeholder="请输入通知回调" disabled></el-input>
            </el-form-item>
            <el-form-item label="会员优惠">
              <el-input size="small" v-model="editForm.vipYouHuiPrice" auto-complete="off" placeholder="请输入加密类型" disabled></el-input>
            </el-form-item>
            <el-form-item label="活动优惠">
              <el-input size="small" v-model="editForm.activityYouHuiPrice" auto-complete="off" placeholder="请输入商户签名密钥" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="购买商品">
          <el-input size="small" v-model="editForm.newContent" auto-complete="off" placeholder="购买的商品" disabled  style="white-space: pre-line;"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Store } from 'vuex'
import { OrderList, OrderRefund, OrderDelete } from '../../api/payMG'
import Pagination from '../../components/Pagination'

import {getOrder,getSalesTime} from '@/api/api.js'
import { Empty } from 'element-ui'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      date:'',
      year:'',
      month:'',
      day:'',
      orderStatus:'',//订单类型
      orderList:'',//订单列表
      selectTime:[],//选择的时间
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    let endDate = new Date();
    //把当前时间减10天，赋值到开始时间
    let startDate = new Date().setDate(endDate.getDate() - 1);
    let date = [startDate,endDate]
    this.selectTime = date
    this.getData(date);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单数据
    getData(date){
      this.loading = true
      let startDate = new Date(date[0]);
      let endDate = new Date(date[1]);
      this.startTime =
      startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      this.endTime =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);
        getSalesTime({
            startTime:this.startTime,
            endTime:this.endTime,
            storeId:localStorage.getItem('storeId')
      }).then((res)=>{
        this.loading = false
        if(res.code == 0){
            let list = [];
            //把对象的每个值，存到数组中
            for (let i in res.data) {
                //如果某一个值是空，就把它的orderCount，profit，salePrice属性变成0
                // console.log(res.data[i]=={})
                if (!res.data[i].orderCount) {
                    res.data[i].orderCount = 0;
                    res.data[i].profit = 0;
                    res.data[i].salePrice = 0;
                }
              list.push(res.data[i]);
            }
          this.orderList = list;
        }
      })
    },
    // 选择时间
    selectListTime(date){
      this.getData(date)
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      console.log(index,row,'333333')
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/pay/timeFilter.vue